import BasePresenter from '@src/js/separate-logic/base-presenter';
import { reaction } from 'mobx';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';

export default class AddonScaleViewPresenter extends BasePresenter {
    /**
     * 这里注册移动端编辑态页面切换时缩略图占位的图标显示更改reaction
     */
    public componentDidMount() {
        const { isPlayState } = this.props;
        if (browser.isMobile && !isPlayState) {
            const currentSlideIndex = this.getSelectionService()?.currentSlideIndex;
            // 编辑态slide-list-m 占位图更换图标策略
            this.updatePVisi(currentSlideIndex);
            this.disposeOnUnmount(reaction(
                () => currentSlideIndex,
                (index) => {
                    this.updatePVisi(index);
                },
            ));
        }
    }

    /**
     * snapshotUrl拉取回来后注册编辑态banner更新
     * @param nextProps 判断snapshotUrl
     */
    public componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        if (nextProps.snapshotUrl !== this.props.snapshotUrl) {
            this.disposeOnUnmount(reaction(
                () => this.getSelectionService()?.currentSlideIndex,
                (index) => {
                    this.updateBannerVisi(index);
                },
            ));
        }
    }

    /**
     * MiniProgram复制链接
     */
    @dispatchProps()
    public handleMiniProgramCopyLink() {
        this.getLinkManager().linkFloatBarService.handleCopyUrl(this.props.src);
    }

    /**
     * 进入index页面时，将真实dom占位图的图标留下来，其余的页面去掉图标
     * @param index slideIndex
     */
    private updatePVisi = (index) => {
        const pList = this.getChildRef('contentRef')?.querySelectorAll('p') || [];
        if (this.isCurrentSlide(index)) {
            pList.forEach((p) => {
                // eslint-disable-next-line no-param-reassign
                p.style.display = 'block';
            });
        } else if (this.notCurrentSlide(index)) {
            pList.forEach((p) => {
                // eslint-disable-next-line no-param-reassign
                p.style.display = 'none';
            });
        }
    };

    /**
     * 更新slide-list-m 模块的截图banner显示
     * @param index slideIndex
     */
    private updateBannerVisi = (index) => {
        const bannerRef = this.getChildRef('bannerRef');
        if (!bannerRef) return;
        if (this.isCurrentSlide(index)) {
            bannerRef.style.display = 'block';
        } else if (this.notCurrentSlide(index)) {
            bannerRef.style.display = 'none';
        }
    };

    /**
     * 判断是否为非编辑态或编辑态当前页
     * @param index slideIndex
     */
    private isCurrentSlide = index => index === -1 || (index > -1 && index === this.props.index);

    /**
     * 判断是否为编辑态非当前页
     * @param index slideIndex
     */
    private notCurrentSlide = index => index > -1 && index !== this.props.index;

    private getSelectionService(): ISelectionService | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService?.viewableServiceLayer?.selectionService;
    }

    private getLinkManager() {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService?.viewableServiceLayer.linkManager;
    }
}
